module.exports = __webpack_public_path__ + "img/scenario_04.37960880.jpg";